import * as yup from 'yup'

const schema = yup.object().shape({
  approvalType: yup.string(),

  approvalUser: yup.array().when('approvalType', {
    is: 'user',
    then: yup.array().min(1, 'Selecione pelo menos um usuário'),
  }),

  approvalEmailInput: yup.string().when('approvalType', {
    is: 'email',
    then: yup.string().email('Email inválido').trim(),
  }),
  approvalEmailList: yup.array().when('approvalType', {
    is: 'email',
    then: yup
      .array()
      .min(1, 'Adicione pelo menos um e-mail')
      .of(yup.string().email('Email inválido').required('Email é obrigatório')),
  }),
})

export default schema
